import { Button } from "src/components";
import crossIcon from "../../assets/cross.svg";
import { escalateInvoice, postInvoiceRemark } from "src/services/invoice-api";   //M10-11536
import { useToast } from "src/hooks/useToast";
import { useState } from "react";

import { useEventStatus } from "src/hooks/useEventStatus";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";

const InvoiceEscalate = ({
  onCloseModal,
  invoiceData,
  tab,
}: {
  onCloseModal: () => void;
  invoiceData: any;
  company_code?: any[];
  division_code?: any[];
  startDate?: Date | string;
  endDate?: Date | string;
  assignee_id?: any[];
  city?: any[];
  district?: any[];
  state?: any[];
  ordering?: any[];
  status?: any[];
  tab?: string;
  fuidStatusId?: number
}) => {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [remarks, setRemarks] = useState<string>(""); //M10-11536
  const { InvoiceFilters, InvoiceApprovalFilters } = useSelector((state: RootState) => state.invoice);
  const { idTokenDetails } = useSelector((state: RootState) => state.auth);//M10-11536

  const company_code = tab == "entry" ? InvoiceFilters?.company?.[0]?.code : InvoiceApprovalFilters?.company?.[0]?.code;

  const { withEventCheck } = useEventStatus();

  //M10-11536
  const handleEscalate = async () => {
    if (!remarks?.trim()) {
      toast({
        description: "Remarks cannot be empty",
        variant: "destructive",
      });
      return;
    }
    //M10-12161
    if (remarks && remarks.length > 487) {
      toast({
        description: "Remarks cannot be longer than 500 characters.",
        variant: "destructive",
      });
      return;
    }
    //M10-12161
    try {
      setIsLoading(true);

      const stockistId = invoiceData?.stockist_invoice_attachment_id;
      const invoiceId = invoiceData?.invoice?.invoice_id;
      if (!stockistId) {
        toast({ description: "Invalid invoice data. Please try again.", variant: "destructive" });
        return;
      }
      const payload = {
        data: { stockist_invoice_attachment_id: stockistId },
        primary_key: stockistId,
        event_type: "STOCKIST_ATTACHMENT_ESCALATE",
      };
      const payloadRemarks = {
        data: {
          invoice_remarks_hdr: 22,
          invoice_id: invoiceId ? invoiceId : null,
          stockist_invoice_attachment_id: stockistId,
          freetxt_remarks: `${"ESCALATED : " + remarks?.trim()}` || "",
          remarkby_type: idTokenDetails?.["custom:role"],
          is_private: false,
        },
        primary_key: stockistId,
        event_type: "STOCKIST_INVOICE_REMARK_ADD",
      };
      // Escalate invoice
      const escalateResponse = await escalateInvoice(payload, company_code);
      // Wait for event completion if required
      await withEventCheck(
        async () => { }, // optional callback
        escalateResponse?.data?.data?.eventStreamCreated?.streamId,
        company_code  //M10-12758
      );
      // Add remark after escalation
      const remarkResponse = await postInvoiceRemark(payloadRemarks, invoiceData?.company_code);
      if (remarkResponse?.status !== 200) throw new Error("Failed to add remark");
      setRemarks("");
      toast({ description: "Invoice escalated successfully", variant: "default" });
    } catch (error) {
      console.error("Error escalating invoice:", error);
      toast({ description: "Failed to escalate invoice", variant: "destructive" });
    } finally {
      setIsLoading(false);
      onCloseModal();
    }
  };
  //M10-11536

  return (
    <div className="flex flex-col gap-y-2 w-[500px] mx-auto bg-white p-4 border border-gray-300 shadow-lg rounded-lg">
      <div className="flex justify-between items-center">
        <p className="text-normal py-1 font-semibold text-[#1B1A1F]">Escalate Invoice</p>
        <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
          <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
        </Button>
      </div>
      {/* M10-11536 */}
      <p className="text-sm mt-2 font-normal text-[#666666]">Remarks</p>
      <textarea value={remarks} onChange={(e) => setRemarks(e.target.value)} placeholder=" " className="p-2 mb-2 resize-none border bg-[#f7f7f7] max-h-[120px] h-[120px] border-gray-300 rounded-md" />
      {/* M10-11536 */}
      <div className="flex justify-end gap-x-2">
        <Button disabled={isLoading || !remarks.trim()}  isLoading={isLoading} loaderSize="small" className="text-white bg-[#8051FF] mt-4" onClick={handleEscalate}>
          Proceed
        </Button>
        <Button disabled={isLoading} className="bg-[#f5f5f5]  mt-4" onClick={onCloseModal}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default InvoiceEscalate;
